import React from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import Drawer from 'rc-drawer';
import { history } from 'store';
import OrgSurveyCompareList from 'components/Agile/OrgSurveyCompare/OrgSurveyCompareList';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

export class Component extends React.Component {
    constructor() {
        super();
    }

    componentDidMount() {
        this.props.showOrgSurveyLoader();
        this.props.fetchOrgSurveysCompare();
    }

    onOrgSurveyCompareSelect = (survey) => {
        const { onOrgSurveyCompareSelect } = this.props;
        onOrgSurveyCompareSelect(survey);
    };
    onToggleOrgSurveyDrawer = () => {
        this.props.onToggleOrgSurveyDrawer();
    };
    handleOrgSurveyRequestClose = () => {
        this.props.handleOrgSurveyRequestClose();
    };
    onFilterOrgSurveyOptionSelect = (option) => {
        // this.props.onFilterOrgOptionSelect(option);
    };
    onCompareSelected = () => {
        history.push('/app/org-survey-compare-radar/default');
    };
    onEngagementDetails = () => {
        history.push('/app/org-survey-engagement-details/default');
    };
    onAllSurveySelect = () => {
        // const selectAll = this.props.selectedEmps < this.props.empList.length;
        // if (selectAll) {
        //     this.props.getAllEmp();
        // } else {
        //     this.props.getUnselectedAllEmp();
        // }
    };

    /**
    Can the survey result be generated (i.e. buttons enabled)
     */
    compareReadyFromSelections = () => {
        let compareReady = false;
        const { orgSurveyCompareList } = this.props;
        if (Array.isArray(orgSurveyCompareList)) {
            return orgSurveyCompareList.filter((entry) => entry.selected).length === 2;
        }
        return compareReady;
    };

    SurveySideBar = () => {
        return (
            <div className="module-side">
                <div className="module-side-header">
                    <div className="module-logo">
                        <i className="zmdi zmdi-city-alt mr-4" />
                        <span>
                            <IntlMessages id="sidebar.compareSurveys" />
                        </span>
                    </div>
                </div>
                <div className="module-side-content">
                    <CustomScrollbars className="module-side-scroll scrollbar" style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                        <div className="module-add-task">
                            <Button className="btn-block jr-btn" color="primary" onClick={this.onCompareSelected} disabled={!this.compareReadyFromSelections()}>
                                <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                                <span>Compare selected</span>
                            </Button>
                        </div>
                        <div className="module-add-task" style={{ marginTop: '-40px' }}>
                            <Button className="btn-block jr-btn" color="primary" onClick={this.onEngagementDetails} disabled={!this.compareReadyFromSelections()}>
                                <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                                <span>Engagement details</span>
                            </Button>
                        </div>
                    </CustomScrollbars>
                </div>
            </div>
        );
    };

    render() {
        const { alertMessage, showMessage, drawerState, noContentFoundMessage, loader, orgSurveyCompareList } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">
                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleOrgSurveyDrawer.bind(this)}
                            sidebar={this.SurveySideBar()}
                        />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">{this.SurveySideBar()}</div>
                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none" onClick={this.onToggleOrgSurveyDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <span>{<IntlMessages id="compare.survey.header.message" />}</span>
                        </div>
                        <div className="module-box-content">
                            <CustomScrollbars className="module-list-scroll scrollbar" style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ? (
                                    <div className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                ) : orgSurveyCompareList?.length === 0 ? (
                                    <div className="h-100 d-flex align-items-center justify-content-center">{noContentFoundMessage}</div>
                                ) : (
                                    <OrgSurveyCompareList orgSurveysCompare={orgSurveyCompareList} onOrgSurveyCompareSelect={this.onOrgSurveyCompareSelect.bind(this)} />
                                )}
                            </CustomScrollbars>
                        </div>
                    </div>
                </div>

                {showMessage && NotificationManager.success(alertMessage, this.handleOrgSurveyRequestClose())}
                <NotificationContainer />
            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/Component.js